import React from 'react';

export const optionsDropdownsContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '18px'
};

export const leftDropdownStyle: React.CSSProperties = {
    width: '100%',
    marginRight: '6px'
}
;
export const rightDropdownStyle: React.CSSProperties = {
    width: '100%',
    marginLeft: '6px'
};

export const allDropdownsContainerStyle: React.CSSProperties = {
    marginBottom: '30px'
};